var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: [_setup.breakpointName, "lexon-button-container"] },
    [
      _c(
        "button",
        {
          class: ["lexon-button", { disabled: _vm.disabled }],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _setup.lexonButtonEvent.apply(null, arguments)
            },
          },
        },
        [_vm._v(" " + _vm._s(_setup.getText) + " ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }